import * as React from 'react';

const CompletedProjectArrowRight = React.forwardRef<HTMLDivElement | null>((_, ref) => {
  return (
    <div
      className={'swiper-arrow arrow-right'}
      onClick={(event) => {
        event.stopPropagation();
      }}
      ref={ref}
    >
      <svg
        fill={'none'}
        height={24}
        viewBox={'0 0 24 24'}
        width={24}
        xmlns={'http://www.w3.org/2000/svg'}
      >
        <path
          d={'M6 12H18M18 12L13 7M18 12L13 17'}
          strokeLinecap={'round'}
          strokeLinejoin={'round'}
          strokeWidth={2}
          stroke={'#ffffff'}
        />
      </svg>
    </div>
  );
});

export default CompletedProjectArrowRight;